import React from 'react';
import CrudLayoutContainer from 'src/components/crud-layout-component/CrudLayoutContainer';
import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import RoutingUtil from 'src/utils/RoutingUtil';
import PermissionHOC from 'src/hoc/PermissionHOC';
import { UnAuthorizedErrorPage } from 'src/utils/CommonUtils';
import { userEditAction, userSearchAction } from './actions/UserActions';
import UserFrom from './UserFrom';
import UserPermissions from './UserPermissions';
import SearchContainerWithPermission from '../search-container/SearchContainerWithPermission';

const data = [
    {
        title: 'Manage',
        link: '/user/manage',
        component: () => (
            <PermissionHOC
                scope="people.user_manager.manage"
                fallback={<UnAuthorizedErrorPage />}
            >
                <UserFrom />
            </PermissionHOC>
        ),
    },
    {
        title: 'Search',
        link: '/user/search',
        component: () => (
            <SearchContainerWithPermission
                scope="people.user_manager.search"
                editScope="people.user_manager.search.edit"
                fallback={<UnAuthorizedErrorPage />}
                reducer="UserReducer"
                dataPath="search"
                editAction={userEditAction}
                redirectUrlOnEdit={RoutingUtil.userManagerUrl()}
                action={userSearchAction}
                columns={{
                    userId: {
                        display: 'User Id',
                    },
                    personalInfo: [
                        {
                            display: 'First Name',
                            path: 'personalInfo.firstName',
                        },
                        {
                            display: 'Last Name',
                            path: 'personalInfo.lastName',
                        },
                    ],
                    employmentType: {
                        display: 'Employment Type',
                    },
                    userType: {
                        display: 'User Type',
                    },
                    designation: {
                        display: 'Designation',
                    },
                    reportingManagerId: {
                        display: 'RM',
                        path: 'reportingManagerId.personalInfo.firstName',
                    },
                    active: {
                        display: 'Active',
                    },
                    by: {
                        display: 'By',
                        path: 'by.personalInfo.firstName',
                    },
                    updatedBy: {
                        display: 'Updated By',
                        path: 'updatedBy.personalInfo.firstName',
                    },
                    ts: {
                        display: 'Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                    updatedTs: {
                        display: 'Updated Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                }}
            />
        ),
    },
    {
        title: 'User Permissions',
        link: '/user/permissions',
        component: () => (
            <PermissionHOC
                scope="people.user_manager.user_permissions"
                fallback={<UnAuthorizedErrorPage />}
            >
                <UserPermissions />
            </PermissionHOC>
        ),
    },
];

const UserContainer = () => (
    <CrudLayoutContainer
        title="User Manager"
        tabs={data}
        routes={data}
    />
);

UserContainer.propTypes = {

};

export default UserContainer;
